import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

function NoCallsCard() {
  const { t } = useTranslation();
  return (
    <div className="flex justify-center pt-5 pb-10">
      <Typography>{t("Δεν_υπάρχουν_ενεργές_κλήσεις.")}</Typography>
    </div>
  );
}

export default NoCallsCard;
